import { Component, OnDestroy, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  Validators,
  AbstractControl,
  ValidationErrors,
} from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { Subscription } from "rxjs";
import { DataService } from "src/app/shared/Services/data.service";
import { countriesData } from "src/app/shared/Services/countries_data";
import {
  SearchCountryField,
  CountryISO,
  PhoneNumberFormat,
} from "ngx-intl-tel-input";

@Component({
  selector: "app-cost-config",
  templateUrl: "./cost-config.component.html",
  styleUrls: ["./cost-config.component.scss"],
})
export class CostConfigComponent implements OnInit, OnDestroy {
  breadCrumbItems = [
    { label: "Configuration" },
    { label: "Cost", active: true },
  ];
  errmsg: any = "";
  countriesjson = countriesData;
  configCost: any[] = [];
  currencySymbols: any[] = [];
  costForm!: FormGroup;
  subscriptions: Subscription[] = [];
  isCatagery: boolean = false;
  currentview = "Fixed";
  costTypeData: any = [
    { value: "fixed", costType: "Fixed" },
    { value: "variable", costType: "Variable" },
  ];
  costValue: any;
  currentPage = 1;
  itemsPerPage = 5;
  pageSize: number = 0;
  selectedType: string = "fixed";
  currencySymbol: string = "₹";
  action: "Add" | "Edit" = "Add";
  editCostId!: string;
  editUser: any;
  delcostId!: string;
  submitted = false;
  user: any;
  custId: any;
  siUnits = [
    { label: "Kilogram (kg)", value: "kg" },
    { label: "Gram (g)", value: "g" },
    { label: "Milligram (mg)", value: "mg" },
    { label: "Meter (m)", value: "m" },
    { label: "Centimeter (cm)", value: "cm" },
    { label: "Millimeter (mm)", value: "mm" },
    { label: "Litre (L)", value: "l" },
    { label: "Millilitre (mL)", value: "ml" },
    { label: "Square Meter (m²)", value: "m2" },
    { label: "Cubic Meter (m³)", value: "m3" },
    { label: "Second (s)", value: "s" },
    { label: "Minute (min)", value: "min" },
    { label: "Hour (h)", value: "h" },
    { label: "Newton (N)", value: "n" },
    { label: "Pascal (Pa)", value: "pa" },
    { label: "Joule (J)", value: "j" },
    { label: "Watt (W)", value: "w" },
    { label: "Hertz (Hz)", value: "hz" },
    { label: "Coulomb (C)", value: "c" },
    { label: "Volt (V)", value: "v" },
    { label: "Ohm (Ω)", value: "ohm" },
    { label: "Lux (lx)", value: "lx" },
    { label: "Kelvin (K)", value: "k" },
    { label: "Mole (mol)", value: "mol" },
    { label: "Person", value: "person" },
  ];
  searchText = "";
  separateDialCode = false;
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  PhoneNumberFormat = PhoneNumberFormat;
  finalRes: any = [];
  preferredCountries: CountryISO[] = [
    CountryISO.India,
    CountryISO.UnitedStates,
    CountryISO.Singapore,
    CountryISO.Malaysia,
    CountryISO.Philippines,
    CountryISO.Indonesia,
  ];

  constructor(
    private modalService: NgbModal,
    private fb: FormBuilder,
    private dataService: DataService,
    private toastr: ToastrService
  ) {
    this.user = JSON.parse(sessionStorage.getItem("currentUser"));
    this.custId = this.user["user"]["custId"];
  }

  ngOnInit() {
    this.fetchData();
    this.prepareCurrencySymbols();
  }

  fetchData() {
    this.toastr.info("We are fetching data", "Info");
    this.getCost();
  }

  getCost() {
    const subscription = this.dataService.get("api/cost").subscribe(
      (res: any) => {
        this.configCost = res || [];
        this.selectType(this.selectedType);
      },
      (error) => {
        this.toastr.error("Server Unreachable");
        this.configCost = [];
      }
    );
    this.subscriptions.push(subscription);
  }

  selectType(data) {
    if (data == "fixed") {
      this.currentview = "fixed";
    } else if (data == "variable") {
      this.currentview = "Variable";
    }
    let resData = [];
    this.configCost.map((elm) => {
      if (data == elm["costType"]) {
        resData.push(elm);
      }
    });
    this.finalRes = resData;
  }

  prepareCurrencySymbols() {
    for (const obj of this.countriesjson) {
      this.currencySymbols.push({
        costId: this.currencySymbols.length + 1,
        currency: obj.currency,
        currency_name: obj.currency_name,
        currency_symbol: obj.currency_symbol,
        currencyName: obj.currencyName,
      });
    }
  }

  onCountryChange(event: any) {
    console.log(event, "event");
    const match = this.currencySymbols.find((c) =>
      c.currency_name.toLowerCase().includes(event.name.toLowerCase())
    );
    this.currencySymbol = match?.currency_symbol || "₹";
  }

  initializeForm(data: any = null) {
    if (this.selectedType == "fixed") {
      if (data?.currencyUnit) this.currencySymbol = data?.currencyUnit || "₹";
      this.costForm = this.fb.group({
        costName: [
          { value: data?.costName || "", disabled: !!data?.costName },
          Validators.required,
        ],
        cost: [
          data?.countryData || null,
          [Validators.required, this.costValidator],
        ],
        currencyUnit: [
          data?.currencyUnit || this.currencySymbol,
          Validators.required,
        ],
      });
    } else if (this.selectedType == "variable") {
      if (data?.currencyUnit) this.currencySymbol = data?.currencyUnit || "₹";
      this.costForm = this.fb.group({
        costName: [
          { value: data?.costName || "", disabled: !!data?.costName },
          Validators.required,
        ],
        cost: [
          data?.countryData || null,
          [Validators.required, this.costValidator],
        ],
        currencyUnit: [
          data?.currencyUnit || this.currencySymbol,
          Validators.required,
        ],

        materialPerPart: [
          data?.materialPerPart || "",
          [Validators.pattern(/^\d{1,8}(\.\d{0,2})?$/)],
        ],
        materialPerHour: [
          data?.materialPerHour || "",
          [Validators.pattern(/^\d{1,8}(\.\d{0,2})?$/)],
        ],
        materialType: [data?.materialType || "Material Per Part"],
        unit: [data?.unit || "", Validators.required],
      });
    }
  }

  // onNumberOnly(event: Event, controlName: string): void {
  //   const input = event.target as HTMLInputElement;
  //   const cleaned = input.value.replace(/[^0-9]/g, "").slice(0, 8);
  //   this.costForm.get(controlName)?.setValue(cleaned, { emitEvent: false });
  // }

  openModal(content: any, data: any, act: "Add" | "Edit") {
    this.costValue = "";
    this.action = act;
    this.modalService.open(content, { backdrop: "static", centered: true });
    if (this.selectedType == "fixed") {
      if (act === "Add") {
        this.currencySymbol = "₹";
        this.initializeForm();
      } else {
        this.costValue = data?.cost;
        this.editCostId = data?.id;
        this.editUser = data;
        this.initializeForm(data);
      }
    } else if (this.selectedType == "variable") {
      if (act === "Add") {
        this.currencySymbol = "₹";
        this.initializeForm();
      } else {
        this.costValue = data?.cost;
        this.editCostId = data?.id;
        this.editUser = data;
        this.initializeForm(data);
      }
    }
  }

  costValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (!value || typeof value !== "object" || !value.nationalNumber) {
      return { required: true };
    }
    const digits = value.nationalNumber.replace(/\D/g, "");
    return /^\d{1,8}$/.test(digits) ? null : { pattern: true };
  }

  limitTo8Digits(event: any) {
    let input = event.target.value.replace(/\D/g, "");
    input = input.slice(0, 8);
    this.costForm.get("cost")?.setValue(input, { emitEvent: false });
  }

  isZero: Boolean = false;

  limitTo8DigitswithDecimel(event: any) {
    this.isZero = false;
    this.toastr.clear();

    let value: string = event.target.value;
    value = value.replace(/[^0-9.]/g, "");

    const firstDotIndex = value.indexOf(".");
    if (firstDotIndex !== -1) {
      value =
        value.substring(0, firstDotIndex + 1) +
        value.substring(firstDotIndex + 1).replace(/\./g, "");
    }

    if (value.length === 1 && value !== "0") {
      this.isZero = false;
      value = "0" + value; // Prepend 0 if it's single digit **AND NOT '0'**
    } else {
      if (value == "0") {
        this.toastr.info("Value should not be Zero");
        this.isZero = true;
      }
    }

    if (value.length > 2 && value.startsWith("0")) {
      value = value.slice(1); // Remove leading 0 if typing continues
    }

    if (value.length > 8) {
      value = value.substring(0, 8);
    }

    this.costValue = value;

    let data = this.formatCostValue(value);
    this.costForm.get("cost")?.setValue(data, { emitEvent: false });
  }

  formatCostValue(value: string | number): string {
    const num = Number(value);
    if (isNaN(num)) return "";

    if (value.toString().includes(".")) {
      return num.toFixed(2);
    }
    return value.toString();
  }

  get form() {
    console.log(this.costForm.controls, "this.costForm.controls");
    return this.costForm.controls;
  }

  cancel() {
    this.modalService.dismissAll();
    this.submitted = false;
    this.action = "Add";
  }

  saveData() {
    if (this.selectedType == "fixed") {
      this.submitted = true;
      if (this.costForm.invalid) {
        if (this.form.cost.errors.required) {
          this.toastr.error("Enter Cost Value");
        }
        return;
      }

      const formValue = this.costForm.getRawValue();
      const payload = {
        custId: this.custId,
        costName: formValue.costName,
        cost: formValue.cost?.number || formValue.cost,
        currencyUnit: this.currencySymbol,
        countryData: formValue.cost,
        costType: this.selectedType,
      };

      if (this.action === "Add") {
        const subscription = this.dataService
          .post("api/cost", payload)
          .subscribe(
            (res: any) => {
              this.toastr.success("Cost Added Successfully", "Success");
              this.cancel();
              this.getCost();
            },
            (error) => {
              this.toastr.error(error.message);
            }
          );
        this.subscriptions.push(subscription);
      } else if (this.action === "Edit") {
        const subscription = this.dataService
          .put(`api/cost?id=${this.editCostId}`, payload)
          .subscribe(
            (res: any) => {
              this.toastr.success("Cost Updated Successfully", "Success");
              this.cancel();
              this.getCost();
            },
            (error) => {
              this.toastr.error(error.message);
            }
          );
        this.subscriptions.push(subscription);
      }
    } else if (this.selectedType == "variable") {
      this.submitted = true;
      if (this.costForm.invalid) {
        return;
      }
      let payload = {};
      const formValue = this.costForm.getRawValue();
      if (formValue.materialType == "Material Per Part") {
        payload = {
          custId: this.custId,
          costName: formValue.costName,
          cost: formValue.cost?.number || formValue.cost,
          currencyUnit: this.currencySymbol,
          countryData: formValue.cost,
          materialPerPart: formValue.materialPerPart || "",
          materialPerHour: "",
          unit: formValue.unit,
          materialType: formValue.materialType,
          costType: this.selectedType,
        };
      } else if (formValue.materialType == "Material Per Hour") {
        payload = {
          custId: this.custId,
          costName: formValue.costName,
          cost: formValue.cost?.number || formValue.cost,
          countryData: formValue.cost,
          currencyUnit: this.currencySymbol,
          materialPerPart: "",
          materialPerHour: formValue.materialPerHour || "",
          unit: formValue.unit,
          materialType: formValue.materialType,
          costType: this.selectedType,
        };
      }

      if (this.action === "Add") {
        const subscription = this.dataService
          .post("api/cost", payload)
          .subscribe(
            (res: any) => {
              this.toastr.success("Cost Added Successfully", "Success");
              this.cancel();
              this.getCost();
            },
            (error) => {
               this.toastr.error(error.message);
            }
          );
        this.subscriptions.push(subscription);
      } else if (this.action === "Edit") {
        const subscription = this.dataService
          .put(`api/cost?id=${this.editCostId}`, payload)
          .subscribe(
            (res: any) => {
              this.toastr.success("Cost Updated Successfully", "Success");
              this.cancel();
              this.getCost();
            },
            (error) => {
              this.toastr.error(error.message);
            }
          );
        this.subscriptions.push(subscription);
      }
    }
  }

  openModalDelete(template: any, item: any) {
    this.delcostId = item.id;
    this.modalService.open(template, { backdrop: "static", centered: true });
  }

  delete(id: string) {
    const subscription = this.dataService.delete(`api/cost?id=${id}`).subscribe(
      (res: any) => {
        this.toastr.success("Cost deleted successfully", "Success");
        this.modalService.dismissAll();
        this.getCost();
      },
      (error) => {
        this.toastr.error(
          error === "Server Unreachable" ? error : "Error",
          "Error"
        );
      }
    );
    this.subscriptions.push(subscription);
  }

  onPageChange(pageNum: number) {
    this.pageSize = this.itemsPerPage * (pageNum - 1);
  }

  ngOnDestroy() {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }
}
